import { Component, OnDestroy, Input, OnChanges } from '@angular/core';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { CentersCentersService } from 'src/app/services/centers-services/centers-centers-service/centers-centers.service';
import { EMPTY, Subscription } from 'rxjs';
import { FormGroup, FormControl } from '@angular/forms';
import { catchError, tap } from 'rxjs/operators';

@Component({
  selector: 'app-centers-center-languages-card',
  templateUrl: './centers-center-languages-card.component.html',
  styleUrls: ['./centers-center-languages-card.component.scss']
})
export class CentersCenterLanguagesCardComponent implements OnChanges, OnDestroy {

  @Input() center;
  @Input() languages;
  @Input() assignedLanguages;
  saveLanguagesInternalIdSubscription: Subscription;
  updateCenterDefaultLanguageSubscription: Subscription;
  basicDataForm = new FormGroup({
    defaultLang: new FormControl(null)
  });

  constructor(private centersCentersService: CentersCentersService,
              private snackbarService: SnackBarService) { }

  ngOnChanges() {
    if (this.center) {
      this.resetForm();
    }
  }

  public defaultLanguageChanged(e) {
    this.updateCenterDefaultLanguageSubscription = this.centersCentersService.updateCenterDefaultLanguage(this.center.InternalId, e.InternalId).pipe(
      tap(o => this.snackbarService.open('stores-page.snackbar messages.update center success', 'success')),
      tap(o => this.centersCentersService.refreshCenter()),
      catchError(error => { this.centersCentersService.refreshCenter(); this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  private resetForm() {
    this.basicDataForm.patchValue({
      defaultLang: this.center.DefaultLanguage
    });
  }

  public outputEventReceiver(selectedLanguages)  {
    const languagesInternalIdList = new Array();
    for (const d of selectedLanguages) {
      languagesInternalIdList.push(d[1]._data.InternalId);
    }
    this.saveLanguagesInternalIdSubscription = this.centersCentersService.saveCenterLanguages(this.center.InternalId, languagesInternalIdList).pipe(
      tap(o => this.snackbarService.open('stores-page.snackbar messages.update center success', 'success')),
      tap(o => this.centersCentersService.refreshCenter()),
      catchError(error => { this.centersCentersService.refreshCenter(); this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; } )
    ).subscribe();
  }

  public setPreselected(op1, op2) {
    if (op1 && op2) {
      return op1.InternalId === op2.InternalId;
    }
  }

  ngOnDestroy() {
    if (this.saveLanguagesInternalIdSubscription) { this.saveLanguagesInternalIdSubscription.unsubscribe(); }
  }
}
